'use es6';

import { Component } from 'react';
import ModalIFrame from 'ui-addon-iframeable/host/ModalIFrame';
import PortalIdParser from 'PortalIdParser';
import enviro from 'enviro';
import emptyFunction from 'react-utils/emptyFunction';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getHost } from 'ContentEditorUI/redux/selectors/routingSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
const WIDTH = 918;
const PADDING_TOP_BOTTOM = 60;
function isSameHost() {
  return enviro.deployed('content-creator') || enviro.get('content-creator') === 'local';
}

/**
 * @param {Object} props
 * @param {string} props.contentType (required)
 * @param {number} props.contentId (required)
 * @param {Function} props.onClose (required)
 * @param {boolean} [props.hasDndArea] (optional)
 * @param {string} [props.previewKey] (optional)
 * @param {number[]} [props.additionalTemplateTypeIds] (optional)
 */
class TemplateSelectModal extends Component {
  constructor(props) {
    super(props);
    this.handleOnMessage = ({
      payload: {
        type
      }
    }) => {
      if (type === 'UPDATE_SUCCESS') {
        window.location.reload();
      }
      if (type === 'UPDATE_ERROR') {
        FloatingAlertStore.addAlert({
          message: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `swapTemplate.swapError.${this.props.contentType}`
          }),
          titleText: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "swapTemplate.swapError.title"
          }),
          type: 'danger'
        });
      }
    };
    this.handleIframeLoaded = () => {
      this.setState({
        isIframeLoaded: true
      });
    };
    this.handleClose = () => {
      const {
        onClose
      } = this.props;
      this.setState({
        isIframeLoaded: false
      });
      onClose();
    };
    this.state = Object.assign({}, this.getModalSize(), {
      isIframeLoaded: false
    });
    this.resizeModal = this.resizeModal.bind(this);
  }
  componentDidMount() {
    window.addEventListener('resize', this.resizeModal);
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.resizeModal);
  }
  getModalSize() {
    return {
      width: WIDTH,
      height: Math.floor(document.documentElement.clientHeight - PADDING_TOP_BOTTOM * 2)
    };
  }
  resizeModal() {
    this.setState(this.getModalSize());
  }
  getContentCreatorUrl() {
    let url = `/email/${PortalIdParser.get()}/create/embedded-dialog`;
    if (!isSameHost()) {
      url = `${getHost()}${url}`;
    }
    return url;
  }
  render() {
    const {
      contentType,
      contentId,
      hasDndArea,
      previewKey,
      additionalTemplateTypeIds
    } = this.props;
    const {
      isIframeLoaded,
      height,
      width
    } = this.state;
    return /*#__PURE__*/_jsx(ModalIFrame, {
      onClose: this.handleClose,
      onReady: emptyFunction,
      onMessage: this.handleOnMessage,
      src: this.getContentCreatorUrl(),
      width: width,
      height: height,
      embeddedPassthruProps: {
        contentType,
        contentId,
        isChangeTemplateDialog: true,
        additionalTemplateTypeIds,
        hasDndArea,
        previewKey
      },
      showLoadingIndicator: !isIframeLoaded,
      iframePassthruProps: {
        id: 'template-swap-embed',
        onLoad: this.handleIframeLoaded
      }
    });
  }
}
TemplateSelectModal.defaultProps = {
  hasDndArea: null
};
export default TemplateSelectModal;